import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { Language } from '@/types/api'

import { LanguageApi } from '@/api/languageApi'

class LanguageCachedDataService extends BaseCachedDataService<Array<Language>> {
    constructor () {
        super([])
    }

    async loadData () {
        const res = await LanguageApi.getAll()

        return this.data = res ?? []
    }
}

export default new LanguageCachedDataService()
